import { useQuery } from '@tanstack/react-query';
import requests from 'service/api';
import SearchSelect from '../search-select';
import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';

export function SelectReferanceCode4({ name,other }) {
  const { values } = useFormikContext();
  const [selected, setSelected] = useState(null);

  const { data = [], isFetched,refetch } = useQuery({
    queryKey: ['/list', 'referance'],
    queryFn: async () => {
      try {
        const { data } = await requests.referance.list();
        console.log('Gelen Data:', data); // Gelen veriyi konsola yazdır
        return data;
      } catch (error) {
        console.error('API Error:', error);
        return []; // Hata durumunda boş bir dizi döndür
      }
    },
    placeholderData: [], // Başlangıçta boş bir dizi
  });

  const isWasgingLabel = Array.isArray(data)
    ? data.filter((item) => item.labelCategory === 'KEMER KARTI')
    : [];

    console.log("wasginggg",data)
  const options = isWasgingLabel.map(({ id, code }) => ({
    value: id,
    label: code,
  }));
  useEffect(() => {
    refetch();
    // eslint-disable-next-line
  }, [other]);

  useEffect(() => {
    console.log('Formik Values:', values); // Formik values değerini konsola yazdır
    if (values?.beltLabel?.[0]?.referanceCode && isFetched) {
      const select = options.find(({ value }) => value === values.beltLabel[0].referanceCode);
      setSelected(select || null); // Eşleşme bulunamazsa null olarak ayarla
    }
    // eslint-disable-next-line
  }, [values?.beltLabel?.[0]?.referanceCode, isFetched ]);

  return (
    <SearchSelect
      name={name}
      label="Referans Kodu"
      options={options}
      value={selected || null} // `selected` boşsa null döndür
      onChange={(e) => setSelected(e)}
    />
  );
}
